// extracted by mini-css-extract-plugin
module.exports = {"container":"vtb-cart-container-module__container___3nGPQ","sticky":"vtb-cart-container-module__sticky___2qce0"};